import { render, staticRenderFns } from "./bibliographyInf.vue?vue&type=template&id=cb0a16c6&scoped=true"
import script from "./bibliographyInf.vue?vue&type=script&lang=js"
export * from "./bibliographyInf.vue?vue&type=script&lang=js"
import style0 from "./bibliographyInf.vue?vue&type=style&index=0&id=cb0a16c6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a16c6",
  null
  
)

export default component.exports